export default "__VITE_ASSET__B37rdZAy__"